<button *ngIf="canais.length" #gatilho type="button" class="cv-gatilho" (click)="alternar()" [class.cv-gatilho--aberto]="aberto"
        [attr.aria-expanded]="aberto" [attr.aria-label]="'Canais de venda: ' + abertas + ' lojas abertas'"
        aria-haspopup="dialog" aria-controls="canais-venda-painel">
  <i class="fe-shopping-bag" aria-hidden="true"></i><span class="cv-gatilho__nome">Canais de venda</span>
  <span class="cv-contagem" [class.cv-contagem--atencao]="abertas !== canais.length || !canais.length">
    <span class="cv-ponto" aria-hidden="true"></span>{{abertas}}<span class="cv-contagem__texto"> {{abertas === 1 ? 'loja aberta' : 'lojas abertas'}}</span>
  </span>
  <i class="fe-chevron-down cv-seta" aria-hidden="true"></i>
</button>

<section *ngIf="aberto" id="canais-venda-painel" class="cv-painel" role="dialog" aria-labelledby="canais-venda-titulo"
         [style.top.px]="topo" [style.left.px]="esquerda" [style.width.px]="largura"
         [style.max-height]="'calc(100dvh - ' + (topo + 12) + 'px)'" cdkTrapFocus [cdkTrapFocusAutoCapture]="true"
         (keydown)="teclado($event)">
  <header class="cv-cabecalho">
    <div class="cv-cabecalho__icone"><i class="fe-shopping-bag" aria-hidden="true"></i></div>
    <div class="cv-cabecalho__texto"><h2 id="canais-venda-titulo">Canais de venda</h2><p>Acompanhe suas lojas integradas em um só lugar.</p></div>
    <button type="button" class="cv-fechar" (click)="fechar()" aria-label="Fechar canais de venda" cdkFocusInitial><i class="fe-x" aria-hidden="true"></i></button>
  </header>
  <div class="cv-resumo" [class.cv-resumo--atencao]="abertas !== canais.length || !canais.length" aria-live="polite">
    <span><span class="cv-ponto" aria-hidden="true"></span><strong>{{abertas}} de {{canais.length}} lojas abertas</strong></span>
    <button type="button" (click)="atualizar()" [disabled]="atualizando || !canais.length">
      <i class="fe-refresh-cw" aria-hidden="true"></i>{{atualizando ? 'Atualizando…' : 'Atualizar status'}}
    </button>
  </div>
  <div class="cv-lista">
    <article class="cv-canal" *ngFor="let canal of canais; trackBy: identifiqueCanal">
      <div class="cv-marca" [ngClass]="'cv-marca--' + canal.marca" aria-hidden="true">
        <img *ngIf="canal.logo" [src]="canal.logo" alt="">
        <span *ngIf="canal.marca === '99food'">99</span>
        <span *ngIf="!canal.logo && canal.tipo === 'keeta'">Keeta</span>
        <i *ngIf="!canal.logo && canal.tipo !== 'keeta' && canal.marca !== '99food'" class="fe-shopping-bag"></i>
      </div>
      <div class="cv-identidade">
        <span class="cv-parceiro">{{canal.rotulo}}</span><h3>{{canal.nome}}</h3>
        <span class="cv-situacao" [ngClass]="'cv-situacao--' + canal.situacao"><span class="cv-ponto" aria-hidden="true"></span>{{titulos[canal.situacao]}}</span>
        <small *ngIf="canal.loja.ultimaAtualizacaoStatus">Última consulta: {{canal.loja.ultimaAtualizacaoStatus | date:'dd/MM HH:mm'}}</small>
        <small *ngIf="!canal.loja.ultimaAtualizacaoStatus">Horário da última consulta não informado.</small>
        <small *ngIf="canal.loja.origemStatus === 'HORARIO_LOCAL'">Estado baseado no horário local; não consultado no parceiro.</small>
        <p class="cv-mensagem" *ngIf="canal.mensagem">{{canal.mensagem}}</p>
      </div>
      <div class="cv-acoes">
        <button type="button" class="cv-acao" [class.cv-acao--fechar]="canal.situacao === 'aberta'"
                [class.cv-acao--abrir]="canal.situacao === 'fechada'" *ngIf="canal.controlavel"
                (click)="alterar(canal)" [disabled]="canal.loja.processando">
          <i class="fe-power" aria-hidden="true"></i>{{canal.loja.processando ? 'Aguarde…' : (canal.situacao === 'aberta' ? 'Fechar loja' : 'Abrir loja')}}
        </button>
        <a class="cv-acao cv-acao--integracao" [routerLink]="canal.url" (click)="fechar(false)"><i class="fe-link" aria-hidden="true"></i>Ver integração</a>
        <small *ngIf="!canal.controlavel && canal.loja.origemStatus !== 'HORARIO_LOCAL'">Gerencie a abertura no painel do parceiro.</small>
        <small *ngIf="canal.loja.origemStatus === 'HORARIO_LOCAL'">Gerencie a abertura pelos horários da loja.</small>
      </div>
    </article>
    <div class="cv-vazio" *ngIf="!canais.length"><i class="fe-shopping-bag" aria-hidden="true"></i><strong>Nenhum canal configurado</strong><p>Adicione uma integração nas configurações da loja.</p></div>
  </div>
  <footer class="cv-rodape"><i class="fe-info" aria-hidden="true"></i><span>Ativação da integração e abertura da loja são estados diferentes.</span></footer>
</section>
